import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MobileTabBar } from "@/components/shared";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Browse from "@/pages/Browse";
import ProfessionalProfile from "@/pages/ProfessionalProfile";
import ClientDashboard from "@/pages/ClientDashboard";
import ProDashboard from "@/pages/ProDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentReturn from "@/pages/PaymentReturn";

function Protected({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading || user === null)
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream">
                <div className="h-10 w-10 rounded-full border-2 border-terracotta border-t-transparent animate-spin" />
            </div>
        );
    if (!user) return <Navigate to="/auth" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}

function Dashboard() {
    const { user } = useAuth();
    if (!user) return <Navigate to="/auth" replace />;
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "professional") return <Navigate to="/pro" replace />;
    return <Navigate to="/cliente" replace />;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/professionisti" element={<Browse />} />
                        <Route path="/professionista/:id" element={<ProfessionalProfile />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/cliente" element={<Protected roles={["client"]}><ClientDashboard /></Protected>} />
                        <Route path="/pro" element={<Protected roles={["professional"]}><ProDashboard /></Protected>} />
                        <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
                        <Route path="/payment/success" element={<PaymentReturn />} />
                        <Route path="/payment/cancel" element={<PaymentReturn />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <MobileTabBar />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
